import { Outlet, useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "../../store/hooks";
import { useEffect } from "react";
import { setLocale } from "../../store/slices/localeSlice";

export const LanguageHandler = () => {
  const { lang } = useParams<{ lang: string }>();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const supportedLanguages = ["en", "de", "fr"];

    if (!lang) {
      navigate("/", { replace: true });
      return;
    }

    if (supportedLanguages.includes(lang)) {
      dispatch(setLocale(lang));
    } else {
      navigate("/", { replace: true });
    }
  }, [lang, dispatch, navigate]);

  return <Outlet />;
};
